import React, {Component, ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {StyledPageTitle} from '../../../components/reservations/components/CommonStyle'
import {CenterRowFlexContainer, FullWidthLeftColumnFlexContainer} from '../../../styledComponents/FlexComponents'
import {PlainStyledButton} from '../../../styledComponents/Button'
import styled from 'styled-components'
import {BreakPoint, Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {Box} from '@mui/material'
import {
    GuestLoginInfoSessionStorageKey,
    NatGuestLoginInfoSessionStorageHelper,
} from '../../common/authentication/NatGuestLoginInfoSessionStorageHelper'
import {convertToRoomNumberForResident, getQueryParameter} from '../../common/util/Natutil'
import {DisplayItemDividerForPageTop} from '../../../styledComponents/DisplayItem'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPenToSquare} from '@fortawesome/free-regular-svg-icons/faPenToSquare'
import {faFileLines} from '@fortawesome/free-regular-svg-icons/faFileLines'
import {generateMedia} from 'styled-media-query'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {
    createGuestWithErrorHandlingPage,
    GuestWithErrorHandlingPagePropsSet,
} from '../../../components/shared/hoc/createGuestWithErrorHandlingPage'
import NatGuestLoginRepo from '../login/repository/NatGuestLoginRepo'
import {
    AVAILABLE_SITE,
    DO_OR_NOT,
    FIRST_LOGIN_REFERRER_ID,
    OWNERSHIP_TRANSFER_CONDITION,
    ROLE_FOR_GUEST,
    TWO_FACTOR_AUTH_CATEGORY,
    YES_OR_NOT
} from '../../../CodeMaster'
import {NatOwnershipTransfersRepo} from '../ownershipTransfers/repository/NatOwnershipTransfersRepo'
import {StyledImg} from '../../../styledComponents/StyledTypeDefinitions'
import {AppGuestContext} from '../../../app/AppGuestContext'
import {Messages} from '../../../Messages'
import {ERROR_ICON_MAP} from '../error/NatGuestSystemErrorPage'
import NatSessionRepo from '../session/repository/NatSessionRepo'
import {OwnershipTransferSubmitStatusDetail} from '../ownershipTransfers/repository/NatGetOwnershipTransferSubmitStatus'
import {CookieHelper} from '../../../CookieHelper'
import {Location} from 'react-router-dom'

interface Props {
    location: Location
    guestLoginRepo: NatGuestLoginRepo
    ownershipTransfersRepo: NatOwnershipTransfersRepo
    sessionRepo: NatSessionRepo
}

interface States {
    isLoadCompleted: boolean
    isSubmittedApply: boolean
    isPossibleSutekiNetRegister: boolean
    loginUserRoleId: Nullable<string>
    loginUserCondominiumCd: Nullable<string>
    applyId: Nullable<string>
    twoFactorAuthNecessary: boolean
}

class NatGuestMyPage extends Component<Props & GuestWithErrorHandlingPagePropsSet, States> {
    declare context: React.ContextType<typeof AppGuestContext>

    accessKey: string
    isSessionTimeOut: boolean

    constructor(props: Props & GuestWithErrorHandlingPagePropsSet) {
        super(props)
        this.state = {
            isLoadCompleted: false,
            isSubmittedApply: false,
            isPossibleSutekiNetRegister: false,
            loginUserRoleId: null,
            loginUserCondominiumCd: null,
            applyId: null,
            twoFactorAuthNecessary: false,
        }

        this.clickSubmitOwnershipTransferApplyButton = this.clickSubmitOwnershipTransferApplyButton.bind(this)
        this.clickConfirmOwnershipTransferApplyButton = this.clickConfirmOwnershipTransferApplyButton.bind(this)
        this.clickRegisterSutekiNetButton = this.clickRegisterSutekiNetButton.bind(this)

        this.accessKey = getQueryParameter('accessKey', this.props.location.search)
        this.isSessionTimeOut = getQueryParameter('sessionTimeOut', this.props.location.search) === '1'
    }

    async componentDidMount(): Promise<void> {
        const {eventEmitter} = this.props

        if (!this.accessKey || this.isSessionTimeOut) {
            SessionStorageHelper.removeAllItem()
            this.props.navigate(`/guest/error`, {
                replace: true,
                state: {message: Messages.EOSTG0011.toString()},
            })
            return
        }

        await eventEmitter.showLoading()
        try {
            if (await this.isNecessaryLogin()) {
                await this.loginGuestUser()
            }

            const condominiumCd = NatGuestLoginInfoSessionStorageHelper.getStringItemOrNull(
                GuestLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD,
            )
            const roleId = NatGuestLoginInfoSessionStorageHelper.getStringItemOrNull(
                GuestLoginInfoSessionStorageKey.LOGIN_USER_ROLE_ID,
            )
            if (condominiumCd && roleId) {
                const submitStatusResult = await this.getSubmitStatusResult(condominiumCd)

                if (submitStatusResult) {
                    const ownershipTransferCondition = OWNERSHIP_TRANSFER_CONDITION
                        .codeToEnumConstants(submitStatusResult.ownershipTransferCondition)
                    if (ownershipTransferCondition !== OWNERSHIP_TRANSFER_CONDITION.POSSIBLE) {
                        this.transitionToSystemError(ownershipTransferCondition, roleId)
                        return
                    }
                    this.setState({
                        isSubmittedApply: submitStatusResult.ownershipTransferSubmittedFlag,
                        isPossibleSutekiNetRegister: submitStatusResult.sutekiNetRegisterPossibleFlag,
                        loginUserRoleId: roleId,
                        loginUserCondominiumCd: condominiumCd,
                        applyId: submitStatusResult.applyId,
                    })
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({
                    isLoadCompleted: true,
                    twoFactorAuthNecessary: NatGuestLoginInfoSessionStorageHelper.getStringItemOrNull(
                        GuestLoginInfoSessionStorageKey.TWO_FACTOR_AUTH_NECESSARY) === DO_OR_NOT.DO.value,
                },
            )
        }
    }

    async isNecessaryLogin(): Promise<boolean> {
        const {ownershipTransfersRepo, sessionRepo} = this.props

        // ログインステータスを取得
        const loginStatus = await this.props.asyncCallFunction(
            this.props.sessionRepo.getLoginStatus.bind(sessionRepo),
            () => {
                this.props.navigate(`/guest/error`, {
                    replace: true,
                    state: {message: Messages.EOSTG0010.toString()},
                })
            },
        )

        switch (loginStatus) {
            case AVAILABLE_SITE.NOT_LOGIN.value:
                return true
            case AVAILABLE_SITE.ADMIN.value:
                this.props.navigate('/guest/error', {state: {message: Messages.EOPCG0001.toString()}})
                break
            case AVAILABLE_SITE.RESIDENT.value:
                this.props.navigate('/guest/error', {state: {message: Messages.EOPCG0002.toString()}})
                break
            case AVAILABLE_SITE.GUEST.value:
                const loggedInFlag = CookieHelper.getStringValue('LoggedGtSite')
                if (loggedInFlag !== YES_OR_NOT.YES.value) {
                    // ログイン済ではない場合、ログイン処理を行う
                    return true
                }

                // セッションのアクセスキー取得（URLのアクセスキーと不一致の場合、エラー）
                const getAccessKeyResult = await this.props.asyncCallFunction(
                    ownershipTransfersRepo.getAccessKeyAuthedGuest.bind(ownershipTransfersRepo),
                    () => {
                        this.props.navigate(`/guest/error`, {
                            replace: true,
                            state: {message: Messages.EOSTG0010.toString()},
                        })
                    },
                )

                const selectedCondominiumCd = NatGuestLoginInfoSessionStorageHelper.getStringItemOrNull(
                    GuestLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD,
                )
                if (getAccessKeyResult?.details.accessKey === this.accessKey) {
                    // セッションストレージが存在する場合：同一タブで同一ユーザでログインしているのでなにもしない
                    // セッションストレージが存在しない場合：別タブで同一ユーザでログインしているのでログインする
                    return !selectedCondominiumCd
                }
                this.props.navigate('/guest/error', {state: {message: Messages.EOPCG0003.toString()}})

            default:
                this.props.navigate('/guest/error', {state: {message: Messages.EOSTG0010.toString()}})
                break
        }
        return false
    }

    async loginGuestUser(): Promise<void> {
        const {guestLoginRepo} = this.props
        // ログアウト
        await this.props.asyncCallFunction(
            this.props.guestLoginRepo.postLogout.bind(this.props.guestLoginRepo),
            () => {
                this.props.navigate(`/guest/error`, {
                    replace: true,
                    state: {message: Messages.EOSTG0010.toString()},
                })
            },
        )
        SessionStorageHelper.removeAllItem()

        // アクセスキーをもとにゲスト画面認証
        const loginResult =
            await this.props.asyncCallFunction(guestLoginRepo.postLogin.bind(guestLoginRepo, this.accessKey),
                () => {
                    this.props.navigate(`/guest/error`, {
                        replace: true,
                        state: {message: Messages.EOSTG0010.toString()},
                    })
                },
            )

        if (loginResult) {
            if (!loginResult.details.errorInfo) {
                NatGuestLoginInfoSessionStorageHelper.setSessionStorageUserInfo(loginResult.details)
                this.context.updateLoginedFlg(true)
            } else {
                this.context.updateLoginedFlg(false)
                SessionStorageHelper.removeAllItem()
                this.props.navigate(`/guest/error`, {
                    replace: true,
                    state: {message: Messages.EOSTG0010.toString()},
                })
            }
        }
    }

    async getSubmitStatusResult(condominiumCd: string): Promise<Nullable<OwnershipTransferSubmitStatusDetail>> {
        const {eventEmitter, ownershipTransfersRepo} = this.props

        const ownershipTransferSubmitStatus = await this.props.asyncCallFunction(
            ownershipTransfersRepo.getOwnershipTransfersSubmitStatus.bind(
                ownershipTransfersRepo, condominiumCd,
            ),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            })
        return ownershipTransferSubmitStatus?.details ?? null
    }

    transitionToSystemError(ownershipTransferCondition: OWNERSHIP_TRANSFER_CONDITION, roleId: string): void {
        let message
        let title

        switch (ownershipTransferCondition) {
            case OWNERSHIP_TRANSFER_CONDITION.SUBMITTED_BY_OTHER:
                title = Messages.EOSTG0001.message
                message = roleId === ROLE_FOR_GUEST.INTERMEDIARY.value ?
                    Messages.EOSTG0002.message : Messages.EOSTG0003.message
                break
            case OWNERSHIP_TRANSFER_CONDITION.WAITING_FOR_INTERMEDIARY:
                title = Messages.EOSTG0006.message
                message = Messages.EOSTG0007.message
                break
            case OWNERSHIP_TRANSFER_CONDITION.SUBMISSION_EXPIRED:
                title = Messages.EOSTG0004.message
                message = Messages.EOSTG0005.message
                break
            case OWNERSHIP_TRANSFER_CONDITION.VIEW_EXPIRED:
                title = Messages.EOSTG0008.message
                message = Messages.EOSTG0009.message
                break
        }

        this.props.navigate(
            '/guest/error',
            {
                replace: true,
                state: {
                    message: message,
                    title: title,
                    icon: ERROR_ICON_MAP.get(title ?? ''),
                },
            },
        )
    }

    clickSubmitOwnershipTransferApplyButton(): void {
        const {applyId, loginUserRoleId, loginUserCondominiumCd, twoFactorAuthNecessary} = this.state

        let seniUrl
        if (loginUserRoleId === ROLE_FOR_GUEST.OLD_MEMBER.value) {
            seniUrl = `/guest/condominiums/${loginUserCondominiumCd}/applications/ownership-transfers/old-member/agreement`
        } else if (loginUserRoleId === ROLE_FOR_GUEST.NEW_MEMBER.value) {
            seniUrl = `/guest/condominiums/${loginUserCondominiumCd}/applications/ownership-transfers/new-member/agreement`
        } else if (loginUserRoleId === ROLE_FOR_GUEST.INTERMEDIARY.value) {
            seniUrl = `/guest/condominiums/${loginUserCondominiumCd}/applications/ownership-transfers/intermediary/agreement`
        }

        twoFactorAuthNecessary
            ? this.props.navigate(`/guest/two-factor-auth/${TWO_FACTOR_AUTH_CATEGORY.OWNERSHIP_TRANSFER.value}/send?seniurl=${seniUrl}`)
            : this.props.navigate(`${seniUrl}`,
                {state: {applyId: applyId}})
    }

    clickConfirmOwnershipTransferApplyButton(): void {
        const {applyId, loginUserRoleId, loginUserCondominiumCd, twoFactorAuthNecessary} = this.state

        let seniUrl
        if (loginUserRoleId === ROLE_FOR_GUEST.OLD_MEMBER.value) {
            seniUrl = `/guest/condominiums/${loginUserCondominiumCd}/applications/ownership-transfers/old-member/confirm/${applyId}`
        } else if (loginUserRoleId === ROLE_FOR_GUEST.NEW_MEMBER.value) {
            seniUrl = `/guest/condominiums/${loginUserCondominiumCd}/applications/ownership-transfers/new-member/confirm/${applyId}`
        } else if (loginUserRoleId === ROLE_FOR_GUEST.INTERMEDIARY.value) {
            seniUrl = `/guest/condominiums/${loginUserCondominiumCd}/applications/ownership-transfers/intermediary/confirm/${applyId}`
        }

        twoFactorAuthNecessary
            ? this.props.navigate(`/guest/two-factor-auth/${TWO_FACTOR_AUTH_CATEGORY.OWNERSHIP_TRANSFER.value}/send?seniurl=${seniUrl}`)
            : this.props.navigate(`${seniUrl}`)
    }

    clickRegisterSutekiNetButton(): void {
        this.state.twoFactorAuthNecessary
            ? this.props.navigate(`/guest/two-factor-auth/${TWO_FACTOR_AUTH_CATEGORY.OWNERSHIP_TRANSFER.value}/send?seniurl=/resident/firstLoginPolicyAgree&referrerId=${FIRST_LOGIN_REFERRER_ID.OWNERSHIP_TRANSFER.value}`)
            : this.props.navigate(`/resident/firstLoginPolicyAgree?referrerId=${FIRST_LOGIN_REFERRER_ID.OWNERSHIP_TRANSFER.value}`)
    }

    renderOwnershipTransferApplyComponent(): Nullable<ReactElement> {
        const condominiumName = NatGuestLoginInfoSessionStorageHelper.getStringItemOrNull(
            GuestLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) ?? ''
        const ridgeName = NatGuestLoginInfoSessionStorageHelper.getStringItemOrNull(
            GuestLoginInfoSessionStorageKey.SELECTED_RIDGE_NAME) ?? ''
        const roomNumber = convertToRoomNumberForResident(NatGuestLoginInfoSessionStorageHelper.getStringItemOrNull(
            GuestLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER) ?? '')
        const displayRoomNumber = `${ridgeName} ${roomNumber}`

        return <>
            <StyledContentsFlexContainer>
                <Box pt={'15px'}>
                    {condominiumName}<br/>{displayRoomNumber}
                </Box>
                <ApplyButtonFlexContainer>
                    <StyledSubmitButton
                        disabled={this.state.isSubmittedApply}
                        onClick={this.clickSubmitOwnershipTransferApplyButton}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} color={Colors.GuestPrimary} fontSize={'38px'}/>
                        <Box pl={'20px'}>申請を提出する</Box>
                    </StyledSubmitButton>
                    <Box width={'30px'}/>
                    <StyledButton
                        disabled={!this.state.isSubmittedApply}
                        onClick={this.clickConfirmOwnershipTransferApplyButton}
                    >
                        <FontAwesomeIcon icon={faFileLines} color={Colors.GuestPrimary}
                                         fontSize={'44px'} width={'44px'}/>
                        <Box pl={'20px'}>申請内容を確認する</Box>
                    </StyledButton>
                </ApplyButtonFlexContainer>
            </StyledContentsFlexContainer>
        </>
    }

    renderSutekiRegisterComponent(): Nullable<ReactElement> {
        return <>
            <Box height={'30px'}/>
            <DisplayItemDividerForPageTop/>
            <SubTitle>マンション専用ポータルサイト<br/>「素敵ネット」</SubTitle>
            <StyledContentsFlexContainer>
                <ApplyButtonFlexContainer>
                    <StyledButton
                        disabled={!this.state.isPossibleSutekiNetRegister}
                        onClick={this.clickRegisterSutekiNetButton}
                    >
                        <SutekiIconImg
                            src={`/resources/images/icons/icon_user_register.svg`}
                        />
                        <Box pl={'20px'}>ユーザ登録をする</Box>
                    </StyledButton>
                </ApplyButtonFlexContainer>
                <StyledNote>
                    ※新組合員様・旧組合員様・仲介業者様すべての方の提出が完了すると、ユーザ登録が可能となります。
                </StyledNote>
            </StyledContentsFlexContainer>
        </>
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return <>
            <Box height={'15px'}/>
            <StyledPageTitle>組合員資格変更届</StyledPageTitle>
            <FullWidthLeftColumnFlexContainer>
                {this.renderOwnershipTransferApplyComponent()}
                {this.state.loginUserRoleId === ROLE_FOR_GUEST.NEW_MEMBER.value &&
                    this.renderSutekiRegisterComponent()
                }
            </FullWidthLeftColumnFlexContainer>
            <Box height={'15px'}/>
        </>
    }
}

NatGuestMyPage.contextType = AppGuestContext
export default createGuestWithErrorHandlingPage(NatGuestMyPage)

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

const StyledContentsFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${breakPoint.lessThan('sp')`
    width:100%;
  `}
  ${breakPoint.greaterThan('sp')`
    padding: 0px 111px;
  `}
`

const ApplyButtonFlexContainer = styled(CenterRowFlexContainer)`
  ${breakPoint.lessThan('sp')`
    flex-direction: column;
    width: 100%
  `}
`

const SubTitle = styled.div`
  font-size: ${FontSize.Accent};
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
  margin-top: 30px;
  width: 100%;
`

const StyledButton = styled(PlainStyledButton)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100px;
  width: 354px;
  margin-top: 20px;
  padding-left: 24px;

  font-size: ${FontSize.Body};
  font-weight: ${FontWeights.Bold};
  border: none;
  background: ${Colors.Surface};
  box-shadow: 0px 2px 2px 0px rgba(112, 112, 112, 0.4);
  border-radius: 4px;
  color: ${Colors.Body};

  :active {
    background: linear-gradient(0deg, rgba(112, 112, 112, 0.75), rgba(112, 112, 112, 0.75)), #D9D9D9;
    box-shadow: none;
  }

  :disabled {
    pointer-events: none;
    background-color: ${Colors.AccentLight};
  }
`

const StyledSubmitButton = styled(StyledButton)`
  padding-left: 30px;
`

const StyledNote = styled.div`
  font-size: ${FontSize.Middle};
  color: ${Colors.Body};
  margin-top: 20px;
`

const SutekiIconImg: StyledImg = styled.img`
  width: 44px;
  height: 44px;
`
